import Swiper from 'swiper/bundle'

export function EmployeeSlider () {
  const SWIPER = new Swiper('.mtt-employees .swiper-container', {
    init: false,
    slidesPerView: 1.4,
    speed: 800,
    spaceBetween: 24,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      501: {
        spaceBetween: 24,
        slidesPerView: 1.8
      },
      651: {
        spaceBetween: 24,
        slidesPerView: 2.4
      },
      701: {
        spaceBetween: 32,
        slidesPerView: 2.4
      },
      951: {
        spaceBetween: 24,
        slidesPerView: 3
      },
      1001: {
        spaceBetween: 32,
        slidesPerView: 3
      },
      1251: {
        spaceBetween: 24,
        slidesPerView: 4
      }
    }
  })

  if (document.querySelector('.mtt-employees .swiper-container')) SWIPER.init()
}

export function TextImageEmployeeSlider () {
  const SWIPER = new Swiper('.mtt-text-image-emp .swiper-container', {
    init: false,
    slidesPerView: 1.4,
    speed: 800,
    spaceBetween: 24,
    watchOverflow: true,
    breakpoints: {
      501: {
        spaceBetween: 24,
        slidesPerView: 1.8
      },
      651: {
        spaceBetween: 24,
        slidesPerView: 2
      }
    }
  })

  if (document.querySelector('.mtt-text-image-emp .swiper-container')) {
    SWIPER.init()
    setTimeout(() => SWIPER.update(), 200) // ie fix
  }
}
